import { z } from 'zod';
import { isoDateSchema, montantSchema, nullableText, round2 } from './common.ts';

export const METHODES_PAIEMENT = ['ESPECES', 'CHEQUE', 'VIREMENT', 'CARTE', 'AUTRE'] as const;
export const methodePaiementSchema = z.enum(METHODES_PAIEMENT);
export type MethodePaiement = z.infer<typeof methodePaiementSchema>;

export const METHODE_PAIEMENT_LABELS: Record<MethodePaiement, string> = {
  ESPECES: 'Espèces',
  CHEQUE: 'Chèque',
  VIREMENT: 'Virement',
  CARTE: 'Carte',
  AUTRE: 'Autre',
};

export const paiementInputSchema = z.object({
  /** Positif = encaissement, négatif = remboursement (règle 9). */
  montant: montantSchema.refine((n) => n !== 0, 'Le montant doit être différent de zéro'),
  date_paiement: isoDateSchema,
  methode: methodePaiementSchema.nullable().default('ESPECES'),
  note: nullableText,
});
export type PaiementInput = z.infer<typeof paiementInputSchema>;

export type Paiement = {
  id: string;
  commande_id: string;
  montant: number;
  date_paiement: string;
  methode: MethodePaiement | null;
  note: string | null;
  created_at: string;
};

/** Avance = somme du grand livre. Jamais stockée (règle 9). */
export function calculerAvance(paiements: readonly { montant: number }[]): number {
  return round2(paiements.reduce((acc, p) => acc + p.montant, 0));
}
